import React from 'react';
import '../css/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          Super League Promotions Sdn Bhd© 2026 All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
